/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as ExpiringRouteImport } from './routes/expiring'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as UsersRouteImport } from './routes/users'
import { Route as EmployeesIndexRouteImport } from './routes/employees.index'
import { Route as EmployeesEmployeeIdRouteImport } from './routes/employees.$employeeId'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as EventsNewRouteImport } from './routes/events.new'
import { Route as FeedbackIndexRouteImport } from './routes/feedback.index'
import { Route as FeedbackEntryIdRouteImport } from './routes/feedback.$entryId'
import { Route as ImportsIndexRouteImport } from './routes/imports.index'
import { Route as ImportsBatchIdRouteImport } from './routes/imports.$batchId'
import { Route as InterventionsIndexRouteImport } from './routes/interventions.index'
import { Route as InterventionsInterventionIdRouteImport } from './routes/interventions.$interventionId'
import { Route as OfoIndexRouteImport } from './routes/ofo.index'
import { Route as OfoOccupationIdRouteImport } from './routes/ofo.$occupationId'
import { Route as ProvidersIndexRouteImport } from './routes/providers.index'
import { Route as ProvidersProviderIdRouteImport } from './routes/providers.$providerId'
import { Route as RecordsIndexRouteImport } from './routes/records.index'
import { Route as RecordsRecordIdRouteImport } from './routes/records.$recordId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpiringRoute = ExpiringRouteImport.update({
  id: '/expiring',
  path: '/expiring',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesIndexRoute = EmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesEmployeeIdRoute = EmployeesEmployeeIdRouteImport.update({
  id: '/employees/$employeeId',
  path: '/employees/$employeeId',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsNewRoute = EventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackIndexRoute = FeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackEntryIdRoute = FeedbackEntryIdRouteImport.update({
  id: '/feedback/$entryId',
  path: '/feedback/$entryId',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportsIndexRoute = ImportsIndexRouteImport.update({
  id: '/imports/',
  path: '/imports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportsBatchIdRoute = ImportsBatchIdRouteImport.update({
  id: '/imports/$batchId',
  path: '/imports/$batchId',
  getParentRoute: () => rootRouteImport,
} as any)
const InterventionsIndexRoute = InterventionsIndexRouteImport.update({
  id: '/interventions/',
  path: '/interventions/',
  getParentRoute: () => rootRouteImport,
} as any)
const InterventionsInterventionIdRoute =
  InterventionsInterventionIdRouteImport.update({
    id: '/interventions/$interventionId',
    path: '/interventions/$interventionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OfoIndexRoute = OfoIndexRouteImport.update({
  id: '/ofo/',
  path: '/ofo/',
  getParentRoute: () => rootRouteImport,
} as any)
const OfoOccupationIdRoute = OfoOccupationIdRouteImport.update({
  id: '/ofo/$occupationId',
  path: '/ofo/$occupationId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProvidersIndexRoute = ProvidersIndexRouteImport.update({
  id: '/providers/',
  path: '/providers/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProvidersProviderIdRoute = ProvidersProviderIdRouteImport.update({
  id: '/providers/$providerId',
  path: '/providers/$providerId',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordsIndexRoute = RecordsIndexRouteImport.update({
  id: '/records/',
  path: '/records/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordsRecordIdRoute = RecordsRecordIdRouteImport.update({
  id: '/records/$recordId',
  path: '/records/$recordId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/expiring': typeof ExpiringRoute
  '/login': typeof LoginRoute
  '/reports': typeof ReportsRoute
  '/users': typeof UsersRoute
  '/employees/$employeeId': typeof EmployeesEmployeeIdRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/events/new': typeof EventsNewRoute
  '/feedback/$entryId': typeof FeedbackEntryIdRoute
  '/imports/$batchId': typeof ImportsBatchIdRoute
  '/interventions/$interventionId': typeof InterventionsInterventionIdRoute
  '/ofo/$occupationId': typeof OfoOccupationIdRoute
  '/providers/$providerId': typeof ProvidersProviderIdRoute
  '/records/$recordId': typeof RecordsRecordIdRoute
  '/employees/': typeof EmployeesIndexRoute
  '/events/': typeof EventsIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/imports/': typeof ImportsIndexRoute
  '/interventions/': typeof InterventionsIndexRoute
  '/ofo/': typeof OfoIndexRoute
  '/providers/': typeof ProvidersIndexRoute
  '/records/': typeof RecordsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/expiring': typeof ExpiringRoute
  '/login': typeof LoginRoute
  '/reports': typeof ReportsRoute
  '/users': typeof UsersRoute
  '/employees/$employeeId': typeof EmployeesEmployeeIdRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/events/new': typeof EventsNewRoute
  '/feedback/$entryId': typeof FeedbackEntryIdRoute
  '/imports/$batchId': typeof ImportsBatchIdRoute
  '/interventions/$interventionId': typeof InterventionsInterventionIdRoute
  '/ofo/$occupationId': typeof OfoOccupationIdRoute
  '/providers/$providerId': typeof ProvidersProviderIdRoute
  '/records/$recordId': typeof RecordsRecordIdRoute
  '/employees': typeof EmployeesIndexRoute
  '/events': typeof EventsIndexRoute
  '/feedback': typeof FeedbackIndexRoute
  '/imports': typeof ImportsIndexRoute
  '/interventions': typeof InterventionsIndexRoute
  '/ofo': typeof OfoIndexRoute
  '/providers': typeof ProvidersIndexRoute
  '/records': typeof RecordsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/expiring': typeof ExpiringRoute
  '/login': typeof LoginRoute
  '/reports': typeof ReportsRoute
  '/users': typeof UsersRoute
  '/employees/$employeeId': typeof EmployeesEmployeeIdRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/events/new': typeof EventsNewRoute
  '/feedback/$entryId': typeof FeedbackEntryIdRoute
  '/imports/$batchId': typeof ImportsBatchIdRoute
  '/interventions/$interventionId': typeof InterventionsInterventionIdRoute
  '/ofo/$occupationId': typeof OfoOccupationIdRoute
  '/providers/$providerId': typeof ProvidersProviderIdRoute
  '/records/$recordId': typeof RecordsRecordIdRoute
  '/employees/': typeof EmployeesIndexRoute
  '/events/': typeof EventsIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/imports/': typeof ImportsIndexRoute
  '/interventions/': typeof InterventionsIndexRoute
  '/ofo/': typeof OfoIndexRoute
  '/providers/': typeof ProvidersIndexRoute
  '/records/': typeof RecordsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/expiring'
    | '/login'
    | '/reports'
    | '/users'
    | '/employees/$employeeId'
    | '/events/$eventId'
    | '/events/new'
    | '/feedback/$entryId'
    | '/imports/$batchId'
    | '/interventions/$interventionId'
    | '/ofo/$occupationId'
    | '/providers/$providerId'
    | '/records/$recordId'
    | '/employees/'
    | '/events/'
    | '/feedback/'
    | '/imports/'
    | '/interventions/'
    | '/ofo/'
    | '/providers/'
    | '/records/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/expiring'
    | '/login'
    | '/reports'
    | '/users'
    | '/employees/$employeeId'
    | '/events/$eventId'
    | '/events/new'
    | '/feedback/$entryId'
    | '/imports/$batchId'
    | '/interventions/$interventionId'
    | '/ofo/$occupationId'
    | '/providers/$providerId'
    | '/records/$recordId'
    | '/employees'
    | '/events'
    | '/feedback'
    | '/imports'
    | '/interventions'
    | '/ofo'
    | '/providers'
    | '/records'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/expiring'
    | '/login'
    | '/reports'
    | '/users'
    | '/employees/$employeeId'
    | '/events/$eventId'
    | '/events/new'
    | '/feedback/$entryId'
    | '/imports/$batchId'
    | '/interventions/$interventionId'
    | '/ofo/$occupationId'
    | '/providers/$providerId'
    | '/records/$recordId'
    | '/employees/'
    | '/events/'
    | '/feedback/'
    | '/imports/'
    | '/interventions/'
    | '/ofo/'
    | '/providers/'
    | '/records/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  ExpiringRoute: typeof ExpiringRoute
  LoginRoute: typeof LoginRoute
  ReportsRoute: typeof ReportsRoute
  UsersRoute: typeof UsersRoute
  EmployeesEmployeeIdRoute: typeof EmployeesEmployeeIdRoute
  EventsEventIdRoute: typeof EventsEventIdRoute
  EventsNewRoute: typeof EventsNewRoute
  FeedbackEntryIdRoute: typeof FeedbackEntryIdRoute
  ImportsBatchIdRoute: typeof ImportsBatchIdRoute
  InterventionsInterventionIdRoute: typeof InterventionsInterventionIdRoute
  OfoOccupationIdRoute: typeof OfoOccupationIdRoute
  ProvidersProviderIdRoute: typeof ProvidersProviderIdRoute
  RecordsRecordIdRoute: typeof RecordsRecordIdRoute
  EmployeesIndexRoute: typeof EmployeesIndexRoute
  EventsIndexRoute: typeof EventsIndexRoute
  FeedbackIndexRoute: typeof FeedbackIndexRoute
  ImportsIndexRoute: typeof ImportsIndexRoute
  InterventionsIndexRoute: typeof InterventionsIndexRoute
  OfoIndexRoute: typeof OfoIndexRoute
  ProvidersIndexRoute: typeof ProvidersIndexRoute
  RecordsIndexRoute: typeof RecordsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expiring': {
      id: '/expiring'
      path: '/expiring'
      fullPath: '/expiring'
      preLoaderRoute: typeof ExpiringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/': {
      id: '/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof EmployeesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/$employeeId': {
      id: '/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof EmployeesEmployeeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/new': {
      id: '/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof EventsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/': {
      id: '/feedback/'
      path: '/feedback'
      fullPath: '/feedback/'
      preLoaderRoute: typeof FeedbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/$entryId': {
      id: '/feedback/$entryId'
      path: '/feedback/$entryId'
      fullPath: '/feedback/$entryId'
      preLoaderRoute: typeof FeedbackEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imports/': {
      id: '/imports/'
      path: '/imports'
      fullPath: '/imports/'
      preLoaderRoute: typeof ImportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imports/$batchId': {
      id: '/imports/$batchId'
      path: '/imports/$batchId'
      fullPath: '/imports/$batchId'
      preLoaderRoute: typeof ImportsBatchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/interventions/': {
      id: '/interventions/'
      path: '/interventions'
      fullPath: '/interventions/'
      preLoaderRoute: typeof InterventionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/interventions/$interventionId': {
      id: '/interventions/$interventionId'
      path: '/interventions/$interventionId'
      fullPath: '/interventions/$interventionId'
      preLoaderRoute: typeof InterventionsInterventionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ofo/': {
      id: '/ofo/'
      path: '/ofo'
      fullPath: '/ofo/'
      preLoaderRoute: typeof OfoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ofo/$occupationId': {
      id: '/ofo/$occupationId'
      path: '/ofo/$occupationId'
      fullPath: '/ofo/$occupationId'
      preLoaderRoute: typeof OfoOccupationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/providers/': {
      id: '/providers/'
      path: '/providers'
      fullPath: '/providers/'
      preLoaderRoute: typeof ProvidersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/providers/$providerId': {
      id: '/providers/$providerId'
      path: '/providers/$providerId'
      fullPath: '/providers/$providerId'
      preLoaderRoute: typeof ProvidersProviderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/records/': {
      id: '/records/'
      path: '/records'
      fullPath: '/records/'
      preLoaderRoute: typeof RecordsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/records/$recordId': {
      id: '/records/$recordId'
      path: '/records/$recordId'
      fullPath: '/records/$recordId'
      preLoaderRoute: typeof RecordsRecordIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  ExpiringRoute: ExpiringRoute,
  LoginRoute: LoginRoute,
  ReportsRoute: ReportsRoute,
  UsersRoute: UsersRoute,
  EmployeesEmployeeIdRoute: EmployeesEmployeeIdRoute,
  EventsEventIdRoute: EventsEventIdRoute,
  EventsNewRoute: EventsNewRoute,
  FeedbackEntryIdRoute: FeedbackEntryIdRoute,
  ImportsBatchIdRoute: ImportsBatchIdRoute,
  InterventionsInterventionIdRoute: InterventionsInterventionIdRoute,
  OfoOccupationIdRoute: OfoOccupationIdRoute,
  ProvidersProviderIdRoute: ProvidersProviderIdRoute,
  RecordsRecordIdRoute: RecordsRecordIdRoute,
  EmployeesIndexRoute: EmployeesIndexRoute,
  EventsIndexRoute: EventsIndexRoute,
  FeedbackIndexRoute: FeedbackIndexRoute,
  ImportsIndexRoute: ImportsIndexRoute,
  InterventionsIndexRoute: InterventionsIndexRoute,
  OfoIndexRoute: OfoIndexRoute,
  ProvidersIndexRoute: ProvidersIndexRoute,
  RecordsIndexRoute: RecordsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
